import { indigo } from "@radix-ui/colors"
import * as turf from "@turf/turf"
import {
	type CircleLayerSpecification,
	type FillLayerSpecification,
	type LineLayerSpecification,
	LngLatBounds,
} from "mapbox-gl"

export const WORLD_LNG_LAT_BOUNDS = new LngLatBounds([-180, -90], [180, 90])

export const MAPBOX_ACCESS_TOKEN = import.meta.env.REACT_APP_MAPBOX_ACCESS_TOKEN

export const MAP_MAX_ZOOM = 22

export const VIEW_ON_MAP_ZOOM = 18

export const BOUNDS_PADDING = 80

export const MAPBOX_DEFUALT_ICON_SIZE = 24

export const EMPTY_SOURCE_ID = "EMPTY_SOURCE"

export const EMPTY_FEATURE_COLLECTION = Object.freeze(turf.featureCollection([]))

export const SELECTED_FEATURE_COLOR = indigo.indigo9

export const DRAW_COLOR = "#fbb03b"

export const DRAW_CIRCLE_LAYER_PAINT: CircleLayerSpecification["paint"] = {
	"circle-radius": 8,
	"circle-color": DRAW_COLOR,
	"circle-stroke-width": 2,
	"circle-stroke-color": "#fff",
}

export const DRAW_LINE_LAYER_PAINT: LineLayerSpecification["paint"] = {
	"line-color": DRAW_COLOR,
	"line-width": 2,
	"line-dasharray": [1, 1],
}

export const DRAW_FILL_LAYER_PAINT: FillLayerSpecification["paint"] = {
	"fill-color": DRAW_COLOR,
	"fill-opacity": 0.6,
}

export const CIRCLE_POLYGON_STEPS = 100

export const POINT_GEOMETRY_TYPE_FILTER = ["==", ["geometry-type"], "Point"]

export const LINE_STRING_GEOMETRY_TYPE_FILTER = ["==", ["geometry-type"], "LineString"]

export const POLYGON_GEOMETRY_TYPE_FILTER = ["==", ["geometry-type"], "Polygon"]

export const VISIBILITY_FILTER = ["==", ["get", "visibility"], "visible"]

export const LINE_PAINT: LineLayerSpecification["paint"] = {
	"line-color": indigo.indigo9,
	"line-width": 2,
	"line-dasharray": [2, 2],
}
